import SEO from "../components/SEO";

const MentionsLegales = () => {
    return (
        <>
            <SEO
                title="Mentions légales — Fiduciaire Bleich"
                description="Mentions légales de la Fiduciaire Bleich Sàrl, Rue de Rive 8, 1204 Genève."
                canonical="https://fiduciaire-bleich.ch/mentions-legales"
            />
            <article
                data-testid="mentions-page"
                className="bg-white py-20 lg:py-28"
            >
                <div className="container-prose max-w-3xl">
                    <div className="inline-flex items-center gap-2 mb-6 text-xs uppercase tracking-[0.25em] text-[#5C6B70]">
                        <span className="w-8 h-px bg-[#1C9CAC]" />
                        Informations légales
                    </div>
                    <h1 className="font-serif text-5xl sm:text-6xl text-[#2C3E45] leading-tight tracking-tight mb-12">
                        Mentions <span className="italic">légales.</span>
                    </h1>

                    <div className="space-y-10 text-[#5C6B70] leading-[1.75]">
                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Éditeur du site
                            </h2>
                            <p>
                                Fiduciaire Bleich Sàrl
                                <br />
                                Rue de Rive 8, 1204 Genève, Suisse
                                <br />
                                IDE : CHE-112.231.914
                                <br />
                                Téléphone : +41 22 319 34 40
                                <br />
                                Email : info@fiduciaire-bleich.ch
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Directeur de la publication
                            </h2>
                            <p>La direction de la Fiduciaire Bleich Sàrl.</p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Hébergement
                            </h2>
                            <p>
                                Hébergeur : Emergent — https://emergent.sh
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Propriété intellectuelle
                            </h2>
                            <p>
                                L'ensemble des éléments présents sur ce site (textes,
                                illustrations, logos, structure) est protégé par le droit suisse
                                de la propriété intellectuelle. Toute reproduction, totale ou
                                partielle, est interdite sans autorisation écrite préalable de
                                la Fiduciaire Bleich Sàrl.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Responsabilité
                            </h2>
                            <p>
                                Les informations diffusées sur ce site sont fournies à titre
                                informatif. La Fiduciaire Bleich Sàrl met tout en œuvre pour
                                assurer leur exactitude mais ne saurait être tenue responsable
                                d'éventuelles erreurs, omissions ou conséquences résultant de
                                leur utilisation. Le contenu de ce site ne constitue pas un
                                conseil fiscal, comptable ou juridique personnalisé.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Liens externes
                            </h2>
                            <p>
                                Ce site peut contenir des liens vers des sites tiers. La
                                Fiduciaire Bleich Sàrl n'exerce aucun contrôle sur ces sites et
                                décline toute responsabilité quant à leur contenu.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                Droit applicable
                            </h2>
                            <p>
                                Le présent site est soumis au droit suisse. Tout litige relatif
                                à son utilisation relève de la compétence exclusive des
                                tribunaux du canton de Genève.
                            </p>
                        </section>

                        <p className="text-sm text-[#5C6B70] italic pt-6 border-t border-[#E5E7EB]">
                            Dernière mise à jour : mai 2026.
                        </p>
                    </div>
                </div>
            </article>
        </>
    );
};

export default MentionsLegales;
